import $http from '@axios'

export default {
  namespaced: true,
  state: {
    formPayload: {
      bank_uuid: '',
      owner_name: '',
      account_number: '',
      account_type: '',
    },
    banksTemp : []
  },
  getters: {},
  mutations: {
    setFormPayload(state, value) {
      state.formPayload = value
    },
     // Add one bank account to banksTemp
    addBankTemp(state, bank) {
      state.banksTemp.push(bank)
    },

    // Remove one bank account (by index)
    removeBankTemp(state, index) {
      state.banksTemp.splice(index, 1)
    },

    // Update a bank account (by index)
    updateBankTemp(state, { index, bank }) {
      state.banksTemp.splice(index, 1, bank)
    },

    // Clear all temporary banks
    clearBanksTemp(state) {
      state.banksTemp = []
    },
  },
  actions: {
    getData(context, { params }) {
      return new Promise((resolve, reject) => {
        $http.get('/bankAccount', { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    getDetail(context, { uuid, params }) {
      return new Promise((resolve, reject) => {
        $http.get(`/bankAccount/${uuid}`, { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    postData(context, { payload, query }) {
      return new Promise((resolve, reject) => {
        $http.post(`/bankAccount${query || ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteData(context, query) {
      return new Promise((resolve, reject) => {
        $http.delete(`/bankAccount${query || ''}`)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
  },
}
